import { fromJson, JsonResponse } from '@client/core/data/concerns/parses-from-json';
import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { Nullable } from '@client/core/data/types';
import { parseISO } from '@client/core/utils/date';
import { NotificationType } from '@client/features/notifications/types';
import { User } from '@client/features/user/models/user';
import { Project } from '@client/features/project/models/project';

export class DatabaseNotification<T extends Record<string, any> = Record<string, any>> {
  constructor(
    public readonly id: string,
    public readonly type: NotificationType,
    public readonly performedBy: User,
    public readonly projectUuid: Project['uuid'],
    public readonly projectName: Project['name'],
    public readonly data: T,
    public readonly readAt: Nullable<Date>,
    public readonly createdAt: Date,
  ) {}
}

defineTransform(DatabaseNotification, (json: JsonResponse, { fromSnakeCaseKeys, nullOr }) => {
  return {
    ...fromSnakeCaseKeys(),
    performedBy: json.performed_by ? fromJson(User, json.performed_by) : null,
    readAt: nullOr(json.read_at, () => parseISO(json.read_at)),
    createdAt: parseISO(json.created_at),
  };
});
